import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

/**Query file */
import { UserQueryService, BookingsQueryService, RolesQueryService } from '../queryFiles/index';

/**Service file */

import { AuthService } from '../authentication/auth.service';
import { AssignProService } from '../e-commerce/assignPro/assignPro.service';

import { spekwo, apiCalls } from '../utils/index';

@Injectable()
export class CalendarService implements Resolve<any>
{

    spekwo = spekwo;
    schedules: any;
    apiCalls = apiCalls;

    constructor(
        private http: HttpClient,
        /**Service file */
        public authService: AuthService,
        public assignProService: AssignProService,
        /**Query file */
        public userQueryService: UserQueryService,
        public bookingsQueryService: BookingsQueryService,
        public rolesQueryService: RolesQueryService
    ) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.authService.GetUserById()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /* Get all events from backend*/

    getSchedules(role) {

        return new Promise((resolve, reject) => {
            if (role !== this.spekwo.Owner) {
                /* get IC schedules*/
                this.schedules = this.bookingsQueryService.GET_OWN_SCHEDULES();
            }
            else {
                /* get all schedules*/
                this.schedules = this.bookingsQueryService.GET_ALL_SCHEDULES();
            }
            this.schedules
                .valueChanges
                .subscribe((response: any) => {

                    if (response &&
                        response.data &&
                        response.data.allScheduledBookings.edges.length > 0) {
                        resolve(response.data.allScheduledBookings.edges)
                    } else {
                        resolve([]);
                    }
                }, () => {
                    reject;
                })
        })

    }

    /**Get mail id of user */

    getMailOfuser(scheduleForm) {
        return new Promise((resolve, reject) => {

            /**Get mail id of this user */
            this.userQueryService.GET_USER_BASED_UID(scheduleForm.get('assignedTo').value)
                .valueChanges
                .subscribe((response: any) => {

                    if (response &&
                        response.data &&
                        response.data.allUsers &&
                        response.data.allUsers.edges.length) {


                        response.data.allUsers.edges.forEach((user) => {
                            const emailId = user.node.email;
                            resolve(emailId)
                        })
                    } else {
                        reject;
                    }
                }, reject)
        })
    }

    /**Edit schedule */
    editSchedule(scheduleForm, scheduleId) {

        return new Promise((resolve, reject) => {
            /**Update data on schedule bookings */
            this.bookingsQueryService.UPDATE_SCHEDULE_BOOKING_BY_ID(scheduleForm, scheduleId)
                .subscribe((res) => {

                    var userId = scheduleForm.get('assignedTo').value;
                    var currentOrderId = scheduleForm.get('scheduleBookingId').value;
                    this.assignProService.changeStatusOfOrder(currentOrderId, userId)
                        .then(response => {
                            resolve('success')

                        })
                        .catch(() => {
                            resolve('failed')
                        })

                }, () => {
                    reject;
                })
        })
    }

    /*Delete schedule */
    deleteSchedule(event) {
        return new Promise((resolve, reject) => {
            this.bookingsQueryService.DELETE_BOOKING_BY_ORDER_ID(event)
                .subscribe(() => {
                    resolve('success');
                }, () => {
                    reject
                })
        })
    }

    /**Get all pro users */
    getPros() {

        return new Promise((resolve, reject) => {
            this.rolesQueryService.GET_ROLE_ID_BY_ROLE_NAME(this.spekwo.Pro)
                .valueChanges
                .subscribe((response: any) => {

                    if (response && response.data && response.data.allRoles &&
                        response.data.allRoles.edges
                    ) {
                        resolve(response.data.allRoles.edges);
                    } else {
                        resolve([]);
                    }

                }, reject)
        })
    }

    /** Once allocated, send notify to pro's email */
    sendMail(orderId, assignedTo) {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiCalls.sendMail + '?orderId=' + encodeURIComponent(orderId) + '&email=' + encodeURIComponent(assignedTo.trim()))
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        })
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/calendar/calendar.service.ts